export enum VIEW_OPTION {
  TILES = 'tiles',
  LIST = 'list',
}

enum CharType {}
export type Char = string & CharType;
